import environment from "./environment";

const imageExtensions = /\.(avif|bmp|gif|jpe?g|png|svg|webp)$/i;
const pdfExtension = /\.pdf$/i;

export const getFileNameFromUrl = (rawUrl = "") => {
  if (!rawUrl || typeof rawUrl !== "string") return "";
  const path = rawUrl.split("?")[0].split("#")[0];
  return decodeURIComponent(path.split("/").pop() || "");
};

export const buildFileUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== "string") return "";
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return "";
  if (/^(https?:|blob:|data:)/i.test(trimmedUrl)) return trimmedUrl;

  const baseUrl = environment.apiURL || "";
  if (!baseUrl) return trimmedUrl;
  return `${baseUrl.replace(/\/$/, "")}/${trimmedUrl.replace(/^\//, "")}`;
};

export const getFileType = ({ name = "", mimeType = "", type = "" } = {}) => {
  const normalizedMime = String(mimeType || type || "").toLowerCase();
  const normalizedName = getFileNameFromUrl(String(name || "")).toLowerCase();

  if (normalizedMime.startsWith("image/") || imageExtensions.test(normalizedName)) return "image";
  if (normalizedMime === "application/pdf" || pdfExtension.test(normalizedName)) return "pdf";
  return "document";
};

export const canPreviewInline = (file) => ["image", "pdf"].includes(getFileType(file));

export const openFileUrl = (url) => {
  const normalizedUrl = buildFileUrl(url);
  if (!normalizedUrl) return false;

  const openedWindow = window.open(normalizedUrl, "_blank", "noopener,noreferrer");
  if (openedWindow) openedWindow.opener = null;
  return !!openedWindow;
};

const uploadUrlKeys = new Set(["url", "fileUrl", "fileURL", "filePath", "path", "location", "Location", "signedUrl", "signedURL", "publicUrl", "publicURL"]);

export const extractUploadedFileUrl = (payload) => {
  const seen = new Set();

  const visit = (value, key = "") => {
    if (!value) return "";
    if (typeof value === "string") {
      return uploadUrlKeys.has(key) || /^(https?:|\/|uploads?\/|media\/|files?\/)/i.test(value) ? value : "";
    }
    if (typeof value !== "object" || seen.has(value)) return "";

    seen.add(value);

    if (Array.isArray(value)) {
      for (const item of value) {
        const found = visit(item);
        if (found) return found;
      }
      return "";
    }

    for (const preferredKey of uploadUrlKeys) {
      const found = visit(value[preferredKey], preferredKey);
      if (found) return found;
    }

    for (const [childKey, childValue] of Object.entries(value)) {
      const found = visit(childValue, childKey);
      if (found) return found;
    }

    return "";
  };

  return buildFileUrl(visit(payload));
};
